import { FC } from "react";
import { ResponsivePie } from "@nivo/pie";
import clsx from "clsx";
import numeral from "numeral";
import { getContrastTextColor } from "utils/colors";

interface PieProps {
  data: {
    id: string;
    label: string;
    value: number;
    color: string;
    bgColor: string;
  }[];
  innerRadius?: number;
}

const Pie: FC<PieProps> = ({ data, innerRadius = 0.6 }) => (
  <ResponsivePie
    data={data}
    margin={{ top: 20, right: 20, bottom: 20, left: 20 }}
    innerRadius={innerRadius}
    padAngle={0.5}
    cornerRadius={3}
    activeOuterRadiusOffset={8}
    borderWidth={1}
    borderColor={{
      from: "color",
      modifiers: [["darker", 0.2]],
    }}
    colors={{ datum: "data.bgColor" }}
    enableArcLinkLabels={false}
    arcLabelsSkipAngle={10}
    enableArcLabels={true}
    arcLabelsTextColor={({ data }) => getContrastTextColor(data.bgColor)}
    arcLabel={(e) => numeral(e.value).format("0.0a")}
    tooltip={({
      datum: {
        data: { bgColor, label, value },
      },
    }) => (
      <div
        style={{
          padding: "10px 14px",
          background: "white",
          color: "#fff",
          borderRadius: "8px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
          fontSize: "14px",
          fontWeight: 500,
          lineHeight: 1.4,
          whiteSpace: "nowrap",
          pointerEvents: "none", // makes sure it doesn't block hover
          transform: "translateY(-4px)", // subtle lift
          backgroundColor: bgColor,
        }}
        className={bgColor}
      >
        <div
          className={clsx("mb-1 opacity-85 text-black")}
          style={{ color: getContrastTextColor(bgColor) }}
        >
          {label}
        </div>
        <div
          className="text-lg font-600"
          style={{ color: getContrastTextColor(bgColor) }}
        >
          {numeral(value).format("#,#.##")}
        </div>
      </div>
    )}
    motionConfig="gentle"
    transitionMode="pushIn"
    animate={true}
  />
);

export default Pie;
